import React from 'react';
import BasicDrawer from '../../components/Drawer';
import Circular from '../../components/Loader/Circular';
import { Avatar, Col, Divider, Row } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import BasicText from '../../components/Text/BasicText';
import { Colors } from '../../config';
import moment from 'moment';
import { Button } from '../../components';
import { CiEdit } from 'react-icons/ci';
import useColors from '../../hooks/useColors';
import GoogleMapComp from '../../components/GoogleMap';

const UserDetailDrawer = ({
    drawerStates,
    onCloseDrawer,
    detailDrawerReset,
    userDetailLoader,
    userDetailData,
    UserEditHandler,
    isRole,
}) => {
    const { colorPrimary } = useColors();

    const latitude = userDetailData?.data?.latitude;
    const longitude = userDetailData?.data?.longitude;

    return (
        <BasicDrawer
            openDrawer={drawerStates?.userDetailDrawer}
            title={'User Details'}
            onClose={onCloseDrawer}
            afterOpenChange={detailDrawerReset}
            width={'600'}
        >
            {userDetailLoader ? (
                <Circular
                    spinning={userDetailLoader}
                    size={40}
                    color={colorPrimary}
                    containerStyle={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            ) : (
                <Row className="w-full">
                    <Col
                        className="w-full flex flex-col items-center"
                        span={24}
                    >
                        {userDetailData?.profileImg ? (
                            <Avatar
                                size={55}
                                src={userDetailData?.profileImg[0]?.url}
                            />
                        ) : (
                            <Avatar size={55} icon={<UserOutlined />} />
                        )}
                        <BasicText
                            className="text-xl font-semibold text-center"
                            text={
                                userDetailData?.data?.user?.firstName ||
                                    userDetailData?.data?.user?.lastName
                                    ? `${userDetailData?.data?.user?.firstName || ''} ${userDetailData?.data?.user?.lastName || ''}`.trim()
                                    : '-'
                            }
                        />
                        <span>
                            {userDetailData?.data?.user?.phoneNo
                                ? userDetailData?.data?.user?.phoneNo
                                : '-'}
                        </span>
                    </Col>

                    <Divider />

                    <Row className="w-full" justify={'center'} align={'middle'}>
                        <Col span={24} className="flex flex-col mb-3">
                            <span className="text-sm font-semibold text-[#4E5D78] mb-1">
                                Audio
                            </span>
                            {userDetailData?.data?.voiceNote?.length > 0 ? (
                                userDetailData?.data?.voiceNote?.map(
                                    (note, index) => (
                                        <div
                                            key={note?.id || index}
                                            className="my-1 w-full"
                                        >
                                            <audio controls className="w-full">
                                                <source
                                                    src={note?.url}
                                                    type="audio/mpeg"
                                                />
                                                Your browser does not support
                                                the audio element.
                                            </audio>
                                        </div>
                                    ),
                                )
                            ) : (
                                <BasicText
                                    className="text-sm font-medium"
                                    text="-"
                                />
                            )}
                        </Col>

                        <Col span={12} className="flex flex-col">
                            <span className="text-sm font-semibold text-[#4E5D78]">
                                Date Created
                            </span>
                            <BasicText
                                className="text-sm font-medium"
                                text={
                                    userDetailData?.data?.createdAt
                                        ? moment(
                                            userDetailData?.data?.createdAt,
                                        ).format('DD-MM-YYYY hh:mm A')
                                        : '-'
                                }
                            />
                        </Col>

                        <Col span={12} className="flex flex-col">
                            <span className="text-sm font-semibold text-[#4E5D78]">
                                Role
                            </span>
                            <div className="flex items-center justify-start gap-1 flex-wrap">
                                {userDetailData?.data?.user?.userRole?.map(
                                    (role, key) => {
                                        return (
                                            <>
                                                <BasicText
                                                    key={role?.id}
                                                    className="text-sm font-medium"
                                                    text={role?.name}
                                                />
                                            </>
                                        );
                                    },
                                )}
                            </div>
                        </Col>
                    </Row>

                    <Divider />

                    <Row className="w-full" justify={'start'} align={'start'}>
                        <Col span={9} className="w-2/4 flex flex-col">
                            <span className="text-sm font-semibold text-[#4E5D78]">
                                Position{' '}
                            </span>
                            <div className="flex items-center justify-start gap-1 flex-wrap">
                                {userDetailData?.data?.user?.eligibilities
                                    ?.length > 0 ? (
                                    userDetailData?.data?.user?.eligibilities?.map(
                                        (role, key) => (
                                            <BasicText
                                                key={role?.id || key}
                                                className="text-sm font-medium"
                                                text={role?.name}
                                            />
                                        ),
                                    )
                                ) : (
                                    <BasicText
                                        className="text-sm font-medium"
                                        text="-"
                                    />
                                )}
                            </div>
                        </Col>

                        {/* <Col span={9} className="w-2/4 flex flex-col">
                            <span className="text-sm font-semibold text-[#4E5D78]">
                                Closed By
                            </span>
                            <BasicText
                                className="text-sm font-medium break-words"
                                text={
                                    userDetailData?.email
                                        ? userDetailData?.email
                                        : '-'
                                }
                            />
                        </Col> */}
                    </Row>

                    <Divider />
                    <Row className="w-full" justify={'center'} align={'start'}>
                        <Col span={24} className="w-full h-96">
                            <span className="text-sm font-semibold text-[#4E5D78]">
                                Loation
                            </span>
                            {latitude && longitude && (
                                <GoogleMapComp
                                    pointerPosition={[
                                        {
                                            lat: latitude,
                                            lng: longitude,
                                        },
                                    ]}
                                    mapClickHandler={() => { }}
                                />
                            )}
                        </Col>
                    </Row>
                </Row>
            )}
        </BasicDrawer>
    );
};

export default UserDetailDrawer;
